"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.optimiseCourseItinerary = void 0;
const dayjs = require("dayjs");
const _ = require("lodash");
const course_1 = require("../course");
const optimiseCourseItinerary = (formData, rate_matrix, cheapest_combination) => {
    const itinerary = _.cloneDeep(formData?.courses?.itinerary);
    const duration_adjustment = 1;
    // get the date range
    const dates = [];
    const duration = formData?.trip?.duration_days_nights || 0;
    // NOTE: If GOLF+HOTEL need to increase the number of days by 1
    for (let i = 0; i < duration + duration_adjustment; i++) {
        dates.push(dayjs(formData.trip?.start_date).add(i, "day").format("YYYY-MM-DD"));
    }
    const sorted_itinerary = (0, course_1.sortGolfData)(itinerary, cheapest_combination);
    // go through each item and update the date
    const new_itinerary = sorted_itinerary.map((golf, index) => {
        if (!golf)
            return null;
        return {
            ...golf,
            config: {
                ...golf.config,
                where_when_who: {
                    ...golf.config?.where_when_who,
                    date: dates[index],
                },
            },
        };
    });
    // loop through the itinerary and get updated and applicable rate from the rate matrix for that date and course
    const updated_itinerary = new_itinerary.map((golf) => {
        if (!golf)
            return null;
        const date = dayjs(golf?.config?.where_when_who?.date).format("YYYY-MM-DD");
        const todays_matrix = rate_matrix.find((r) => r.date === date);
        const course_rate = todays_matrix?.courses.find((c) => c.config.course?.id === golf?.config.course?.id);
        return course_rate;
    });
    return updated_itinerary;
};
exports.optimiseCourseItinerary = optimiseCourseItinerary;
